import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DocumentLibDto, EntityColumnMetaDto, EntityMetaDto, NotificationMessageDto, RoleDto, RoleTypeEnum, UserDto } from 'src/app/api';
import { CerSessionUserNavigationService } from './cer-session-user-navigation.service';

export class EntityColumnMeta {
  public entity: EntityMetaDto;
  public column: EntityColumnMetaDto;
}

@Injectable({
  providedIn: 'root'
})
export class CerSessionUserService implements OnDestroy {
  private subscriptionManager$: Subscription = new Subscription();

  public user$ = new BehaviorSubject<UserDto>(null);
  public roles$ = new BehaviorSubject<RoleDto[]>(null);
  public documentLibs$ = new BehaviorSubject<DocumentLibDto[]>(null);
  public notifications$ = new BehaviorSubject<NotificationMessageDto[]>(null);
  public userEntities$ = new BehaviorSubject<EntityMetaDto[]>(null);

  public entities$: BehaviorSubject<EntityMetaDto[]> = new BehaviorSubject<EntityMetaDto[]>(null);

  constructor(public navigation: CerSessionUserNavigationService) {
  }

  ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }

  public isAuthenticated: boolean = false;

  public dto(): UserDto {
    return this.isAuthenticated ? this.user$.getValue() : null;
  }

  public id(): number {
    return this.isAuthenticated ? this.dto()?.id : null;
  }

  public name(): string {
    return this.isAuthenticated ? this.dto()?.name : '[Ikke aktiv]';
  }

  public roles(): RoleDto[] {
    return this.roles$.getValue() ?? [];
  }

  public hasRoles() {
    return this.roles()?.length > 0;
  }

  public hasRole(anyOfRequiredRoles: RoleTypeEnum[]): boolean {
    var ok = true;
    if (anyOfRequiredRoles.length > 0) {
      var ok = false;
      if (this.isAuthenticated) {
        this.roles().forEach(r => { if (anyOfRequiredRoles.indexOf(r.id) >= 0) { ok = true; } });
      }
    }
    return ok;
  }

  public documentLibs(): DocumentLibDto[] {
    return this.documentLibs$.getValue();
  }

  public entityByName(name: string): EntityMetaDto {
    if (name == null || name.length == 0) {
      return null;
    }
    const nameLwr = name.toLowerCase();
    return this.entities$.getValue()?.find(e => e.name.toLocaleLowerCase() == nameLwr);
  }

  public columnByName(entity: EntityMetaDto, fieldName: string): EntityColumnMetaDto {
    if (entity == null || fieldName == null || fieldName.length == 0) {
      return null;
    }
    const fieldNameLwr = fieldName.toLowerCase();

    if (fieldName.indexOf('.') > 0) {
      const entityCol: EntityColumnMeta = this.entityColumnMetaGet(fieldName);
      return entityCol?.column;
    }
    else {
      return entity.columns.find(c => c.name.toLowerCase() == fieldNameLwr);
    }
  }

  public entityColumnMetaGet(fieldName: string, navigationName: string = "Navigation"): EntityColumnMeta {
    const parts = fieldName.split('.');
    if (parts?.length <= 1) {
      return null;
    }
    var entityName = parts[0];
    if (entityName.endsWith(navigationName)) {
      entityName = entityName.replace(navigationName, "");
    }
    const entity = this.entityByName(entityName);
    if (!entity) {
      return null;
    }
    const columnName = parts[1];
    const column = this.columnByName(entity, columnName);
    return column ? { entity: entity, column: column } : null;
  }

}
